import { useCallback } from 'react'
import { useTranslation } from 'next-i18next'
import SmartLink from '@components/SmartLink'
import useTracking from '@/lib/tracking/useTracking'
import useLiveInfo from '@/hooks/useLiveInfo'
import useTrackingInfo from '@/hooks/useTrackingInfo'
import styles from './index.module.sass'

const RewardRule = ({ url }) => {
  const { t } = useTranslation()

  const { broadcastId, serviceId, shopId } = useLiveInfo()
  const { screenName } = useTrackingInfo()
  const { tracker } = useTracking()

  const onTracking = useCallback(() => {
    let category
    switch (screenName) {
      case 'live_cart':
        category = 'cart_list'
        break
      case 'live_product':
        category = 'product_list'
        break
      default:
    }
    tracker?.event({
      config: { utsType: 'click' },
      event: {
        screenName,
        category,
        params: {
          target: 'reward_info',
          broadcast_id: broadcastId,
          shop_id: shopId
        }
      }
    })
  }, [tracker, screenName, broadcastId, shopId])

  if (!serviceId || serviceId === 'MYSHOP') {
    return <></>
  }

  return (
    <div className={styles.rewardRule}>
      <SmartLink href={url} className={styles.rewardRuleLink} onClick={onTracking}>
        {t('client.cart.desc.rewardinfo')}
      </SmartLink>
    </div>
  )
}

export default RewardRule
